import React from 'react';
import { useHistory } from "react-router-dom";
import Plan from './plan';
import http from '../services/httpService'

const plans = [ { id: 'plan_HFPVKol8BtHHpX', 
                  name: 'Catter Basic',
                  price: '$5/mth' },
                { id: 'plan_HFPWYojg6bBFi3', 
                  name: 'Catter Basic Annual',
                  price: '$50/year' }]

const apiEndpoint = 'users'

export default function PlanList(props) {
    const history = useHistory();

   const handlePlanSelect = (id) => async (e) => {
        const data = { plan_id: id }
        const config = { headers: { 'Content-Type': 'application/json' }};
        const resp = await http.patch(apiEndpoint + '/' + props.user.identity.id, 
                                      data, 
                                      config);
        console.log(resp);
        // NOTE: Check for success?
        history.push('/checkout');
    }

    return (
        <React.Fragment>
            <h3 className="text-center">Select a Plan:</h3>
            <div className="d-flex flex-column flex-md-row justify-content-center">
                { plans.map(plan => <Plan 
                                        key={ plan.id }
                                        plan={ plan }
                                        onPlanSelect={ handlePlanSelect(plan.id) } />) }
            </div>
        </React.Fragment>
    );
}
